import * as types from './action-types';
import api from '../utils/api';
import getAuth from '../utils/get-auth';

export const requestUserLogin = (credentials) => {
  const { email, password } = credentials;
  return {
    type: types.REQUEST_USER_LOGIN,
    payload: api('/sessions', {
      method: 'POST',
      body: JSON.stringify({ username: email, password })
    })
  };
};

export const receiveUserLogin = (json) => {
  return {
    type: types.RECEIVE_USER_LOGIN,
    payload: json
  };
};

export const receiveUserLoginError = (user, json) => {
  return {
    type: types.RECEIVE_USER_LOGIN_ERROR,
    payload: json,
    error: true
  };
};

export const requestUserLogout = () => {
  return {
    type: types.REQUEST_USER_LOGOUT
  };
};

export const reviveSession = (token = '', user = {}) => {
  return {
    type: types.REVIVE_SESSION,
    token, user
  };
};

export const requestValidateSession = (token, user) => {
  return {
    type: types.REQUEST_VALIDATE_SESSION,
    token, user
  };
};

export const requestUpdateUser = (user) => {
  return (dispatch, getState) => {
    const state = getState();
    const auth = getAuth(state);
    const userId = state.session.user.id;

    dispatch({
      type: types.REQUEST_UPDATE_USER,
      payload: api(`/users/${userId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `JWT ${auth}` },
        body: JSON.stringify(user)
      })
    })
  }
};

/**
 * Updates the local session store with the given object. Instead of
 * replacing the local user object wholesale, it'll instead be merged
 * with the existing model.
 *
 * @param {Object} user A new user object to update the local store with.
 */
export const updateCachedUser = (newUser) => {
  return {
    type: types.UPDATE_CACHED_USER,
    meta: {
      user: newUser
    }
  }
};

export const requestPasswordReset = (user) => {
  return {
    type: types.REQUEST_PASSWORD_RESET,
    payload: api(`/forgot-password`, {
      method: 'POST',
      body: JSON.stringify(user)
    })
  };
}

export const requestRoomChange = (room) => {
  return {
    type: types.REQUEST_ROOM_CHANGE,
    room
  };
}



// WEBPACK FOOTER //
// ./src/actions/session-actions.js